import { StandardEvents } from '@shopify/events';

/**
 * <amq-product-cents-per-night>: "Entspricht n Cent pro Nacht" under the product price
 * (blocks/amq_product_cents_per_night.liquid).
 *
 * Horizon morphs only the variant picker when the customer changes a variant; every other block
 * refreshes itself from the section HTML the picker fetched (see assets/product-price.js). This
 * element listens for the same product select event on its section and swaps its content with the
 * matching element from that HTML, so the cents line always shows the selected variant's price.
 */
class AmqProductCentsPerNight extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {CustomEvent & { promise?: Promise<{ detail?: { html?: Document } }> }} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;

    event.promise
      .then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;

        const next = html.querySelector(`amq-product-cents-per-night[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        this.innerHTML = next.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[amq-product-cents-per-night]', error);
      });
  };
}

if (!customElements.get('amq-product-cents-per-night')) {
  customElements.define('amq-product-cents-per-night', AmqProductCentsPerNight);
}
